import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Backdrop,
  CircularProgress,
  Typography,
  Modal,
  FormControl,
} from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import Header from "../../../components/Header";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../App";
import { tokens } from "../../../theme";
import { useTheme } from "@mui/material";
import {
  userLists,
  getBoards,
  getBoardById,
  addToBoard,
  confirmGifter,
  removeGifter,
  handleRequest,
} from "../../../services/ApiClass";
import { useSnackbar } from "../../../components/SnackbarContext"; // Import useSnackbar
import UserBox from "./user-box";

const BoardDetail = (props) => {
  let { id } = useParams();
  const { state, dispatch } = useContext(AuthContext);
  const navigate = useNavigate();
  const { openSnackbar } = useSnackbar();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [loading, setLoading] = useState(false);
  const [board, setBoard] = useState([]);
  const [users, setUsers] = useState([]);

  const isNonMobile = useMediaQuery((theme) => theme.breakpoints.up("sm"));

  useEffect(() => {
    if (!state.tokenJwt) {
      navigate("/login");
    }
    // userLists().then((response) => {
    //   setUsers(response.output);
    // });
  }, []);

  useEffect(() => {
    setLoading(true);
    getBoardById(id).then((response) => {
      setBoard(response.output);
      // console.log(response);
      setLoading(false);
    });
  }, [id]);

  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    const d = Math.floor(seconds / (3600 * 24));
    const h = Math.floor((seconds % (3600 * 24)) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor(seconds % 60);

    const dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
    const hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
    const mDisplay = m > 0 ? m + (m == 1 ? " minute " : " minutes ") : "";
    const sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
    return dDisplay + hDisplay + mDisplay /* + sDisplay*/;
  };

  const onAddGifter = async (user, gifter) => {
    setLoading(true);
    const response = await addToBoard({
      board_id: board.id,
      user_id: user.id,
    });
    handleRequest(response, openSnackbar);
    if (response.return) {
      setBoard({
        ...board,
        [gifter]: {
          ...board[gifter],
          confirmed: 0,
          user: { ...user },
        },
      });
    }
    setLoading(false);
  };

  const onConfirmGifter = async (gifter) => {
    setLoading(true);
    const response = await confirmGifter({
      board_id: board.id,
      user_id: board[gifter].user_id,
      id: board[gifter].id,
    });
    handleRequest(response, openSnackbar);
    if (response.return) {
      setBoard({
        ...board,
        [gifter]: {
          ...board[gifter],
          confirmed: 1,
        },
      });
    }
    setLoading(false);
  };

  const onRemoveGifter = async (gifter) => {
    setLoading(true);
    const response = await removeGifter({
      board_id: board.id,
      user_id: board[gifter].user_id,
      id: board[gifter].id,
      forced: true,
    });
    handleRequest(response, openSnackbar);
    if (response.return) {
      setBoard({
        ...board,
        [gifter]: undefined,
      });
    }
    setLoading(false);
  };

  return (
    <Box m="20px">
      <Header title="Board" subtitle="Manage Board" />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer - 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Typography sx={{ textAlign: "center" }} variant="h3">
        Board {id} creato il {board.created_at?.replace("T", " ").split(".")[0]}
      </Typography>
      <Box
        display="grid"
        gap="20px"
        gridTemplateColumns={`repeat(3, minmax(0, 1fr${
          !isNonMobile ? ", 1fr" : ""
        }))`}
        sx={{
          "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
          height: "75vh",
        }}
      >
        <Box
          display="grid"
          gap="5%"
          gridTemplateColumns={`repeat(4, minmax(0, 1fr${
            isNonMobile ? ", 1fr" : ""
          }))`}
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
          }}
        >
          <Box sx={{ gridColumn: "span 1" }} />
          <UserBox
            sx={{ gridColumn: "span 1" }}
            title="Left Gifter 1"
            board={board?.gifter1}
            users={users}
            onAddGifter={(username) =>
              onAddGifter(username, "gifter1")
            }
            onConfirmGifter={() => onConfirmGifter("gifter1")}
            onRemoveGifter={() => onRemoveGifter("gifter1")}
          />
          <UserBox
            sx={{ gridColumn: "span 1" }}
            title="Left Gifter 2"
            board={board?.gifter2}
            users={users}
            onAddGifter={(username) =>
              onAddGifter(username, "gifter2")
            }
            onConfirmGifter={() => onConfirmGifter("gifter2")}
            onRemoveGifter={() => onRemoveGifter("gifter2")}
          />
          <Box sx={{ gridColumn: "span 1" }} />
        </Box>
        <Box
          display="grid"
          gap="5%"
          gridTemplateColumns={`repeat(3, minmax(0, 1fr${
            isNonMobile ? ", 1fr" : ""
          }))`}
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
          }}
        >
          <Box sx={{ gridColumn: "span 1" }} />
          <UserBox
            sx={{ gridColumn: "span 1" }}
            title="Legenda"
            legend={board.user}
          />
          <Box sx={{ gridColumn: "span 1" }} />
        </Box>
        <Box
          display="grid"
          gap="5%"
          gridTemplateColumns={`repeat(4, minmax(0, 1fr${
            isNonMobile ? ", 1fr" : ""
          }))`}
          sx={{
            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
          }}
        >
          <Box sx={{ gridColumn: "span 1" }} />
          <UserBox
            sx={{ gridColumn: "span 1" }}
            title="Right Gifter 1"
            board={board?.gifter3}
            users={users}
            onAddGifter={(username) =>
              onAddGifter(username, "gifter3")
            }
            onConfirmGifter={() => onConfirmGifter("gifter3")}
            onRemoveGifter={() => onRemoveGifter("gifter3")}
          />
          <UserBox
            sx={{ gridColumn: "span 1" }}
            title="Right Gifter 2"
            board={board?.gifter4}
            users={users}
            onAddGifter={(username) =>
              onAddGifter(username, "gifter4")
            }
            onConfirmGifter={() => onConfirmGifter("gifter4")}
            onRemoveGifter={() => onRemoveGifter("gifter4")}
          />
          <Box sx={{ gridColumn: "span 1" }} />
        </Box>
      </Box>
    </Box>
  );
};

export default BoardDetail;
